import React from 'react';
import './Footer.css'

const Footer = () => {
    return (
        <div>
            <div className="social">
        <a href="https://www.facebook.com/profile.php?id=100026601137213">
                <i className="fa fa-facebook-square"></i>Facebook
                </a>
                <a href="www.google.com">
                <i className="fa fa-google-plus-square"></i>Google
                </a>
                <a href="https://join.skype.com/invite/wmUTlD4WXTgH">
                <i className="fa fa-skype"></i>Skype
                </a>
                <a href="https://www.linkedin.com/in/ahad-hossain-b37492216/">
                <i className="fa fa-linkedin-square"></i>Linkedin
                </a>
        </div>
        </div>
    );
};

export default Footer;